var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEmptyReceipt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "104px",
    viewBox: "0 0 104 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u505C\\u7E73\\u8CBB\\uFF08\\u7A7A\\uFF09",
    transform: "translate(-268.000000, -479.000000)",
    stroke: "#A9A9A9",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(176.000000, 480.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(93.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5172,74.9975 L57.5172,65.5645 C57.5172,64.0835 58.7172,62.8835 60.1972,62.8835 L69.6312,62.8835 C69.6412,62.9085 69.6422,62.9105 69.6532,62.9355 L57.5692,75.0195 C57.5442,75.0085 57.5422,75.0075 57.5172,74.9975 Z",
    id: "Stroke-1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5073,75.0192 L34.7703,75.0192 C33.2883,75.0192 32.0873,73.8182 32.0873,72.3362 L32.0873,29.4042 C32.0873,27.9222 33.2883,26.7212 34.7703,26.7212 L66.9693,26.7212 C68.4513,26.7212 69.6523,27.9222 69.6523,29.4042 L69.6523,62.8862",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5315,38.3096 L60.2085,38.3096",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5315,47.1748 L60.2085,47.1748",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5315,56.0402 L60.2085,56.0402",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.2401,50.8699 C101.2401,78.6889 78.6891,101.2399 50.8701,101.2399 C23.0511,101.2399 0.5001,78.6889 0.5001,50.8699 C0.5001,23.0509 23.0511,0.4999 50.8701,0.4999 C78.6891,0.4999 101.2401,23.0509 101.2401,50.8699 Z",
    id: "Stroke-11"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyReceipt);
export default __webpack_public_path__ + "static/media/icon_empty_receipt.dc894ac5fe4b27a81063fe8b025f3b9f.svg";
export { ForwardRef as ReactComponent };